<template>
  <div class="shop-order-detail">
    <div class="box teal">
      <van-cell center is-link to="/receivingAddressPick">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <div class="van-address-item__name">{{ addressInfo.name }}</div>
          <div class="van-address-item__address">{{ addressInfo.address }}</div>
        </template>
      </van-cell>
    </div>
    <div class="box" v-for="(i, index) in list" :key="index">
      <div class="header">
        <van-icon name="shop-o"/>
        <span>{{ i.vendorName }}</span>
      </div>
      <van-cell v-for="(item, idx) in i.books" :key="idx">
        <div class="book-item" v-if="item.pdaBook">
          <div class="cover">
						<img v-if="item.pdaBook.coverUrl" :src="item.pdaBook.coverUrl" :key="item.pdaBook.bookId" referrerpolicy="no-referrer" @error="handleErrorImage($event)"/>
						<img v-else :src="defaultCover()" :key="item.pdaBook.bookId"/>
          </div>
          <div class="right">
            <a class="title">{{ item.pdaBook.title }}</a>
            <p>{{ item.pdaBook.author }}</p>
            <p>{{ item.pdaBook.publisher +'/'+  item.pdaBook.publicationDate}}</p>
            <p>
              <span class="price">￥{{ item.pdaBook.price }}</span>
<!--              <span class="stock">库存:{{ item.pdaBook.inventory }}</span>-->
            </p>
          </div>
        </div>
      </van-cell>
    </div>
  </div>
  <van-action-bar>
    <div class="left">
      <span class="van-submit-bar__price">
        ¥<span class="van-submit-bar__price-integer">{{ allPrice }}</span>
      </span>
    </div>
    <van-action-bar-button type="warning" text="取消" @click="onCancel"/>
    <van-action-bar-button type="danger" text="确认提交" @click="onSubmit"/>
  </van-action-bar>
	<van-overlay :show="loading">
		<div class="submit-message">
			<div class="wrapper">
				<van-loading size="40px" vertical color="#38b1a7">提交中...</van-loading>
			</div>
		</div>
	</van-overlay>
</template>

<script>
import {defineComponent, ref, onMounted, computed} from 'vue';
import {Dialog, Toast} from 'vant';
import {confirm} from '@/api/carts';
import {getConsignee, getCarts, getCartNum} from '@/api/users';
import {getConsigneeById} from '@/api/consignees';
import {isNotEmpty, randomBookCover, setCoversCart} from '@/utils/util';
import store from '@/store';
import {submitOrder} from '@/api/orders';
import {useRoute, useRouter} from "vue-router";

export default defineComponent({
  name: 'ShopOrderDetail',
  setup() {
    const addressId = computed(() => {
      return store.state.addressId;
    });
    const uid = computed(() => {
      return store.state.reader.user.uid;
    });
    const route = useRoute();
    const router = useRouter();
    const addressInfo = ref({}); // 用于显示的地址信息
    const addressAll = ref({}); // 所有的地址信息
		const list = ref([]); // 购物车数据
    const loading = ref(false);
    let listIds = []; // 所有图书的id、bookNo和price
    const allPrice = ref(0); // 合计的价格

    // 获取优先收货地址
    const onConsignee = () => {
      getConsignee()
          .then(data => {
            if (isNotEmpty(data)) {
              addressAll.value = data;
              let consigneeAddress = {};
              if (isNotEmpty(data.consigneeAddress)) {
                consigneeAddress = JSON.parse(data.consigneeAddress);
              }
              addressInfo.value = {
                name: data.consignee + '  ' + data.consigneePhone,
                address: consigneeAddress.province + consigneeAddress.city + consigneeAddress.area + consigneeAddress.detail
              };
            }
          })
          .catch((error) => {
            console.error(error);
          });
    };
    // 获取购物车订单
    const onConfirmCarts = () => 	{
      getCarts(route.query.ids)
          .then(data => {
            if (isNotEmpty(data)) {
                const isbns = [];
                allPrice.value = 0;
                listIds = [];
                for (let key in data) {
                  list.value.push({
										vendorName: key,
										books: data[key],
									});
                }
								list.value.forEach(item => {
									item.books.forEach(k => {
											if (isNotEmpty(k.pdaBook)) {
												allPrice.value = allPrice.value + k.pdaBook.price;
												isbns.push(k.pdaBook.isbn);
											}
											listIds.push({id: k.id});
									})
								})
								allPrice.value = allPrice.value.toFixed(2);
								if(isNotEmpty(isbns)){
									setCoversCart(isbns,list.value);
								}
            
            } else {
              allPrice.value = 0;
              listIds = [];
            }
          })
          .catch((error) => {
            console.error(error);
          });
    };
    // 根据id获取单个收货地址
    const onConsigneeById = (id) => {
      getConsigneeById(id)
          .then(data => {
            if (isNotEmpty(data)) {
              addressAll.value = data;
              let consigneeAddress = {};
              if (isNotEmpty(data.consigneeAddress)) {
                consigneeAddress = JSON.parse(data.consigneeAddress);
              }
              addressInfo.value = {
                name: data.consignee + '  ' + data.consigneePhone,
                address: consigneeAddress.province + consigneeAddress.city + consigneeAddress.area + consigneeAddress.detail
              };
            } else {
              addressAll.value = {};
            }
          })
          .catch((error) => {
            console.error(error);
          });
    };
    // 取消
    const onCancel = () => {
      router.push({path: '/shopCart'});
      // Dialog.confirm({
      //   title: '确认取消订单',
      // })
      //     .then(() => {
      //       router.push({path: '/shopCart'});
      //     })
      //     .catch(() => {
      //     });
    };
    // 提交订单
    const onSubmit = () => {
      Dialog.confirm({
        title: '确认收货地址',
        message: addressInfo.value.name+'\n'+addressInfo.value.address,
      })
          .then(() => {
            formData();
          })
          .catch(() => {
          });
    };
    const formData = () => {
      let address = {};
      if (isNotEmpty(addressAll.value.consigneeAddress)) {
        address = JSON.parse(addressAll.value.consigneeAddress);
      }
      const consigneeAddress = address.province + address.city + address.area + address.detail;
      const consigneeDetailed = {
        "province": address.province,
        "city": address.city,
        "area": address.area,
        "detail": address.detail,
        "postCode": addressAll.value.consigneePostcode
      };
      const deliveryInfo = {
        'method': 'delivery',
        'consignee': addressAll.value.consignee,
        'consigneePhone': addressAll.value.consigneePhone,
        'consigneePostcode': addressAll.value.consigneePostcode,
        'consigneeAddress': consigneeAddress,
        'consigneeDetailed': JSON.stringify(consigneeDetailed)
      };
      // 订单详细信息
      let json = [];
      let param = new URLSearchParams();
      listIds.forEach(item => {
        param.append('cartIds[]', item.id);
        json.push({'cartId': item.id});
      });
      const orderData = {
        'deliveryInfo': deliveryInfo,
        'extraInfo': {
          'cartIds': json,
          'uid': uid.value.toString()
        }
      };
      // 添加到待确认
      loading.value = true;
      confirm(param)
          .then(data => {
            if (data === null) {
              // 重新获取购物车数量
              onCartNum();
              submitOrder(orderData)
                  .then(data => {
                    if(data){
                        Toast({message: data});
                        router.push({path: '/personalCenter'});
                    }
                  })
                  .catch((error) => {
                    console.error(error);
                  })
                  .finally(() =>  loading.value = false)
            } else {
              loading.value = false;
              Toast({message: '购买失败'});
            }
          })
          .catch((error) => {
            loading.value = false;
            console.error(error);
          })
    };
    // 获取购物车数量
    const onCartNum = () => {
        getCartNum()
            .then(data => {
                store.commit('setCartNum', data);
            })
            .catch((error) => {
                console.error(error);
            });
    };
    onMounted(() => {
      onConfirmCarts();
			if (addressId.value !== '') {
				onConsigneeById(addressId.value);
			} else {
				onConsignee();
			}
    });
		function handleErrorImage(event){
			event.srcElement.src = randomBookCover();
		}
		function defaultCover(){
			return randomBookCover();
		}
    return {
      addressInfo,
      list,
      allPrice,
      onCancel,
      onSubmit,
      loading,
			handleErrorImage,
			defaultCover
    };
  },
});
</script>

<style scoped lang="less">
@import "../assets/css/box.less";
@import "../assets/css/book.less";
@import "../assets/css/address.less";
@import "../assets/css/submit-message.less";
.shop-order-detail {
  padding-bottom: 100px;
}
</style>
